// Import the functions you need from the SDKs you need

// import firebase from "firebase/firebase-firestore"
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from 'firebase/firestore'
import { getAuth } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyByqo68idYD0EO1_4j8SvSZLNfVPuGB3CM",
  authDomain: "our-wedding-7da29.firebaseapp.com",
  projectId: "our-wedding-7da29",
  storageBucket: "our-wedding-7da29.firebasestorage.app",
  messagingSenderId: "970112874723",
  appId: "1:970112874723:web:7f4443844b4e76f71fedd6",
  measurementId: "G-373V958JLZ"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);

const db = getFirestore(app);
export default db;
